import { memo } from 'react';

import { GeneralLibraryMembersDescription } from '~/components/LibraryBeta/GeneralLibrarySettingsModal/components/GeneralLibraryMembers/GeneralLibraryMembersDescription';
import { GeneralLibraryMembersList } from '~/components/LibraryBeta/GeneralLibrarySettingsModal/components/GeneralLibraryMembers/GeneralLibraryMembersList';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { useWorkspaceMembers } from '~/swr-hooks/members/useWorkspaceMembers';

type GeneralLibraryMembersProps = {
  onGoToSettingsClick: () => void;
};

export const GeneralLibraryMembers = memo(({ onGoToSettingsClick }: GeneralLibraryMembersProps) => {
  const { members } = useWorkspaceMembers();
  const { currentWorkspace } = useCurrentWorkspace();

  if (!currentWorkspace) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <GeneralLibraryMembersDescription
        membersCount={members?.activeMembers?.length}
        onGoToSettingsClick={onGoToSettingsClick}
        workspaceName={currentWorkspace.name}
      />

      <GeneralLibraryMembersList members={members?.activeMembers ?? []} />
    </div>
  );
});

GeneralLibraryMembers.displayName = 'GeneralLibraryMembers';
